// Custom Query

if ( $('.fig-query .content-feed').length ) {
  // console.log('running query')
  // Packery
  var Packery = require('packery')

  var pckry = new Packery('.fig-query .content-feed', {
    // options...
    itemSelector: 'article',
    gutter: 0
  });
}



// WEBPACK FOOTER //
// ./wp-content/themes/figpress-child/src/js/modules/_query.js